import { render, staticRenderFns } from "./MembersItems.vue?vue&type=template&id=190be7e4&scoped=true&"
import script from "./MembersItems.vue?vue&type=script&lang=js&"
export * from "./MembersItems.vue?vue&type=script&lang=js&"
import style0 from "./MembersItems.vue?vue&type=style&index=0&id=190be7e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190be7e4",
  null
  
)

export default component.exports